import axios from "axios";
import React, { useEffect, useState } from "react";
import "./vehicleSelect.scss";
import VehicleRegistration from "./VehicleRegistration";
import { useNavigate } from "react-router-dom";

interface Vehicle {
  id: number;
  brand_name: string;
  model_name: string;
}

interface IPROPS {
  setStoreVehicleInfo: React.Dispatch<React.SetStateAction<any>>;
  storeVehicleInfo: any;
  onClose: () => void;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  currentStep: number;
}

const VehicleSelect: React.FC<IPROPS> = ({
  setStoreVehicleInfo,
  storeVehicleInfo,
  setCurrentStep,
}) => {
  const [vehicleData, setVehicleData] = useState<Vehicle[]>([]);
  const [vehicleAddClicked, setVehicleAddClicked] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem("customer-token");
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  // Fetch vehicles
  const fetchVehicle = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setVehicleData(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }
  };

  useEffect(() => {
    fetchVehicle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle vehicle selection
  const vehicleChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    const selectedVehicle = vehicleData.find(
      (v) => String(v.id) === selectedId
    );
    setStoreVehicleInfo(selectedVehicle || {});
  };

  // Handle Add Vehicle toggle
  const vehicleAddHandler = () => {
    setVehicleAddClicked((prev) => !prev);
  };

  // Handle confirm button click
  const navigateHandler = () => {
    if (storeVehicleInfo?.id) {
      navigate("/vehicle/service");
    }
  };

  return (
    <div className="vehicle-Select-cont" style={{width: vehicleAddClicked ? "50%" : "35%"}}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h2>{vehicleAddClicked ? "Add Vehicle" : "MY CAR"}</h2>
        {!vehicleAddClicked && (
          <div
            className="vehicle-register-cont"
            onClick={vehicleAddHandler}
          >
            <span style={{fontFamily: "Karbon-medium", fontSize: "18px"}}>Add Vehicle</span>
          </div>
        )}
      </div>

      {/* Vehicle Registration */}
      {vehicleAddClicked ? (
        <VehicleRegistration
          fetchVehicle={fetchVehicle}
          setVehicleAddClicked={setVehicleAddClicked}
        />
      ) : (
        <>
          {/* Brand Select */}
          <div className="vehicle-brand">
            <label>Brand</label>
            <select
              disabled
              value={storeVehicleInfo?.id || ""}
              onChange={vehicleChangeHandler}
            >
              <option value="">Select</option>
              {vehicleData.map((vehicle) => (
                <option key={vehicle.id} value={vehicle.id}>
                  {vehicle.brand_name}
                </option>
              ))}
            </select>
          </div>

          {/* Model Select */}
          <div className="vehicle-model">
            <label>Model</label>
            <select
              value={storeVehicleInfo?.id || ""}
              onChange={vehicleChangeHandler}
            >
              <option value="">Select</option>
              {vehicleData.map((vehicle) => (
                <option key={vehicle.id} value={vehicle.id}>
                  {vehicle.model_name}
                </option>
              ))}
            </select>
          </div>

          {/* Confirm Button */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              onClick={navigateHandler}
              disabled={!storeVehicleInfo?.id}
            >
              CONFIRM
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default VehicleSelect;
